import * as event from './rest/event.js';
import * as eventCart from './rest/eventCart.js';
import * as search from './rest/search.js';
import * as poster from './rest/poster.js';
import * as split from './rest/split.js';
import * as language from './rest/language.js';
import * as subscription from './rest/subscription.js';
import * as order from './rest/order.js';
import * as orders from './rest/orders.js';
import * as promo from './rest/promo.js';
import * as bonuses from './rest/bonuses.js';
import * as service from './rest/service.js';
import * as mailSubscription from './rest/mail-subscription.js';
import * as refund from './rest/refund.js';
import * as pay from './rest/pay.js';
import * as cart from './rest/cart.js';
import * as bulkBuyTeacher from './rest/bulkBuyTeacher.js';
import * as bulkBuyStudent from './rest/bulkBuyStudent.js';
import * as user from './rest/user.js';
import * as utils from './rest/utils.js';
import * as calendar from './rest/calendar.js';
import request from './request.js';

/**
 * Объект который предоставляет запросы к Api
 * @name api
 */
export default {
  event,
  eventCart,
  search,
  poster,
  split,
  language,
  subscription,
  order,
  orders,
  cart,
  promo,
  user,
  service,
  mailSubscription,
  refund,
  pay,
  bulkBuyTeacher,
  bulkBuyStudent,
  utils,
  bonuses,
  calendar,
};

export const makeRequest = (params) => request(params);
